import React, {useState, useEffect, useRef} from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import TablePhoneNo from "../../../../components/Tables/TablePhoneNo";
import BlockIcon from '@mui/icons-material/Block';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  Menu,
  ListItemText,
  makeStyles,
  Input
} from "@material-ui/core";
import {
  Search as SearchIcon,
} from "@material-ui/icons";
import { maskedNumber, decryptPhoneNumber, notify} from "../../../../helpers/utility";
import { ClickAwayListener } from "@material-ui/core";
import HeightIcon from '@mui/icons-material/Height';
import * as actions from "../../../../store/actions/actionIndex";
import CallerId from "../../../../components/Modal/CallerId";
import CallProgressBox from "../../../../components/Boxes/CallProgressBox";
import Tooltip from "@material-ui/core/Tooltip";
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import ArticleIcon from '@mui/icons-material/Article';
import ChatModal from "../../../../components/Modal/ChatModal";
import Waveform from "../../../../components/WaveForm/WaveForm";
import GetAppIcon from "@mui/icons-material/GetApp";
import * as XLSX from "xlsx";



const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  columnIcon: {
    backgroundColor: "#0a82da",
    color: "#ffffff",
    padding: "6px",
    fontSize: "32px !important",
    borderRadius: "5px",
    cursor: "pointer",
    margin: "10px",
  
  },
});

function CallAgentHistory(props) {
      const classes = useStyles();
      const [page, setPage] =  useState(0);
      const [rowsPerPage, setRowsPerPage] = useState(10);
     const [BucketData, setBucketData]  =useState(props.callsData)
       const HIDDEN_COLUMNS = ["session_id", "monitor_filename", "ReportUid"];
    const allColumns = props.callsData[0]
  ? Object.keys(props.callsData[0]).filter(col => !HIDDEN_COLUMNS.includes(col))
  : [];
    const [showModal, setShowModal] = useState(false)
    const [sendPhone, setSendPhone] = useState("")
    const [callerId, setCallerId] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [showChatModal, setShowChatModal] = useState(false)
    const [showColumnDropdown, setShowColumnDropdown] = useState(false);
    const [playingSessionId, setPlayingSessionId] = useState(null); 
    const [playingRowKey, setPlayingRowKey] = useState(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [chatData, setChatData] = useState("") ;
const audioRef = useRef(new Audio());
 const [visibleColumns, setVisibleColumns] = useState(
   allColumns.slice(0, 6) 
 );

const COLUMN_STORAGE_KEY = "callVisibleColumns";
  const [open, setOpen] = useState(
    props.agentState === "CALL_PROGRESS" ? true : false
  );
  const [selectedValue, setSelectedValue] = React.useState(
    props.agentState === "CALL_PROGRESS"
      ? { name: "", phone: props.custPhone ? props.custPhone : "" }
      : {}
  );


useEffect(() => {
  setPage(0);
}, [searchQuery]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // dial Call
  const dialHandler = (agentId, phone,  name) => {
    if (props.agentState === "FREE") {
      if(props.campConf.third_party_caller_id === "1" && props.campConf.third_party_caller_id !== null)
        {
          setShowModal(true);
          setSendPhone(decryptPhoneNumber(phone))
        }
        else{
      props.onAgentDial(agentId, phone, "");
      setOpen(true);
      setSelectedValue({ name: name, phone: phone });
        }
    } else {
      alert("Please disconnect the current call first.");
    }
  };
  const handleModalClose = () =>{
    setShowModal(false)
  }

  // Caller ID through
     const handleCaller = (selectId) =>{
  const callerIdToUse = selectId || "";
  setCallerId(callerIdToUse)
  props.onAgentDial(props.agentId, sendPhone, "", "", callerIdToUse);
   setShowModal(false)
  }

    const handleClose = React.useCallback(() => {
      setOpen(false);
      setSelectedValue({ name: "", phone: "" });
    }, [setOpen, setSelectedValue]);
  

  const handleColumnToggle = (column) => {
    const selected = [...visibleColumns];
    const index = selected.indexOf(column);
    if (index > -1) {
      selected.splice(index, 1);
    } else {
      selected.push(column);
    }
    setVisibleColumns(selected);
    localStorage.setItem(COLUMN_STORAGE_KEY, JSON.stringify(selected));
  };
  
   useEffect(() => {
  if (props.callsData && props.callsData.length > 0) {
    // 1️⃣ Sort latest calls first
    const sortedData = [...props.callsData].sort((a, b) => {
      const dateA = new Date(a.call_start_date_time);
      const dateB = new Date(b.call_start_date_time);
      return dateB - dateA;
    });

    // 2️⃣ Filter by search query (decrypting phone)
    if (props.searchQuery && props.searchQuery.trim() !== "") {
      const filteredData = sortedData.filter((item) => {
        const decryptedPhone = decryptPhoneNumber(item.cust_ph_no);
        return decryptedPhone.includes(props.searchQuery.trim());
      });
      setBucketData(filteredData);
    } else {
      setBucketData(sortedData);
    }
    const savedColumns = localStorage.getItem(COLUMN_STORAGE_KEY);
    if (savedColumns) {
      try {
        const parsed = JSON.parse(savedColumns);
        if (Array.isArray(parsed)) {
          const filtered = parsed.filter(col => !HIDDEN_COLUMNS.includes(col));
          setVisibleColumns(filtered);
        }
      } catch (e) {
        console.error("Invalid column config in localStorage", e);
      }
    } else {
      const allColumns = Object.keys(props.callsData[0] || {});
      const filteredColumns = allColumns.filter(col => !HIDDEN_COLUMNS.includes(col));
      setVisibleColumns(filteredColumns.slice(0, 6));
    }
  }
}, [props.callsData, props.searchQuery]);


const playMediaAPI = async (sessionId) => {
    try {
      const url = `${window.Configs.playMediaUrl}?session_id=${sessionId}`;
      const response = await fetch(url);

      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

      const data = await response.json();

      if (data.status === "error") {
        notify(data.message || "Something went wrong");
        return null;
      }

      return data;
    } catch (error) {
      console.error("Error fetching playMediaAPI:", error);
      notify(error.message || "Error occurred");
      return null;
    }
  };

  // ✅ Main audio control logic
  const handlePlayRecording = async (sessionId, key) => {
  const audio = audioRef.current;

  if (playingSessionId === sessionId && playingRowKey === key) {
    if (isPlaying) {
      audio.pause();
      setIsPlaying(false);
    } else {
      await audio.play();
      setIsPlaying(true);
    }
    return;
  }

  const result = await playMediaAPI(sessionId);

  if (!result?.data || result.data.length === 0) {
    audio.pause();
    audio.src = "";
    setIsPlaying(false);
    setPlayingSessionId(null);
    setPlayingRowKey(null);
    return;
  }

  audio.pause();
  audio.src = `${window.Configs.audioUrl}${result.data[0]}`;
  console.log(audio.src)
  await audio.play();

  setPlayingSessionId(sessionId);
  setPlayingRowKey(key); 
  setIsPlaying(true);
};

  useEffect(() => {
    const audio = audioRef.current;
    const handleEnded = () => {
      setIsPlaying(false);
      setPlayingSessionId(null);
    };
    audio.addEventListener("ended", handleEnded);
    return () => audio.removeEventListener("ended", handleEnded);
  }, []);

  // ✅ Cleanup on unmount
  useEffect(() => {
    const audio = audioRef.current;
    return () => {
      audio.pause();
      audio.src = "";
    };
  }, []);

const handleChatModal = () =>{
  setShowChatModal(false)
}
const showTranscript = async (getSessionId, phoneNo,key) => {

  try {
    const response = await fetch(window.Configs.transcriptUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        encrypted_phone_no: phoneNo,
        session_id: getSessionId,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    if (data.status === "failed" || !data.data?.length) {
      notify("No chat records found for this call.");
      setShowChatModal(false);
      return;
    }

    const formattedData = data.data.map(([id, transcriptStr]) => ({
      id,
      transcript: JSON.parse(transcriptStr),
    }));

    setChatData(formattedData); 
    setShowChatModal(true);

    return formattedData;
  } catch (error) {
    console.error("Error fetching transcript:", error);
    notify(error.message || "Failed to fetch transcript");
    return null;
  }
};

// for handleExport
const handleExportData = () => {
  if (!BucketData || BucketData.length === 0) return;

  const phoneColumns = [
    "cust_ph_no"
  ];

  const formatValueForExport = (column, value) => {
    if (!value && value !== 0) return "";
    if (phoneColumns.includes(column)) {
      // if (props.facilityConf && props.facilityConf.enable_number_mask) {
      //   return props.facilityConf.enable_number_mask === "1"
      //     ? maskedNumber(value, props.facilityConf.mask_start_pos, props.facilityConf.mask_end_pos)
      //     : decryptPhoneNumber(value);
      // }
      return decryptPhoneNumber(value);
    }
    return value;
  };

  const dataToExport = BucketData.map((row) => {
    const filteredRow = {};
    visibleColumns.forEach((col) => {
      const header = col
        .replace(/_/g, " ")
        .toLowerCase()
        .replace(/\b\w/g, (c) => c.toUpperCase());

      filteredRow[header] = formatValueForExport(col, row[col]);
    });
    return filteredRow;
  });

  const ws = XLSX.utils.json_to_sheet(dataToExport);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Filtered Data");

  // ✅ Generate filename with local date & time
  const now = new Date();
  const pad = (n) => n.toString().padStart(2, "0");
  const dateStr = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}_${pad(now.getHours())}-${pad(now.getMinutes())}-${pad(now.getSeconds())}`;

  const fileName = `CDR_Report_${dateStr}.xlsx`;

  XLSX.writeFile(wb, fileName);
};


  return (
    <>
     {showModal && (
    <CallerId isOpen = {showModal} onClose={handleModalClose} onCallerIdSelect = {handleCaller} phoneNumber= {sendPhone} />
        )}
        {showChatModal && (
          <ChatModal isOpen = {showChatModal} onClose = {handleChatModal} chatData = {chatData} />
        )}
 
   <Paper className={classes.root}>
     {BucketData.length > 0 ?(
      <>
      <div style={{display: "flex", justifyContent: "end"}}>
        {window.Configs.showCDRExport &&
        <Tooltip title="Export Data" arrow>
        <GetAppIcon
          className={classes.columnIcon}
          onClick={handleExportData}
          style={{ marginLeft: "10px", cursor: "pointer"}}
        />
      </Tooltip>
}
        <ClickAwayListener onClickAway={() => setShowColumnDropdown(false)}>
          <div style={{ position: "relative", display: "inline-block" }}>
            <Tooltip title="Select Columns" arrow>
              <HeightIcon
                className={classes.columnIcon}
                onClick={() => setShowColumnDropdown((prev) => !prev)}
              />
            </Tooltip>
      
            {showColumnDropdown && (
              <div
                style={{
                  position: "absolute",
                  top: "40px",
                  insetInlineEnd: "0", 
                  backgroundColor: "white",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  zIndex: 10,
                  maxHeight: "300px",
                  overflowY: "auto",
                  padding: "10px",
                }}
              >
                {allColumns.map((column) => {
                  if (column === "lead_id") return null;
                  return (
                    <MenuItem key={column} value={column}>
                      <Checkbox
                        checked={visibleColumns.includes(column)}
                        onChange={() => handleColumnToggle(column)}
                        style={{
                          color: visibleColumns.includes(column)
                            ? "#0a82da" 
                            : "#000", 
                        }}
                      />
                      <ListItemText primary={column.replace(/_/g, " ")} />
                    </MenuItem>
                  );
                })}
              </div>
            )}
          </div>
        </ClickAwayListener>
         
        </div>
     <TableContainer
            className={classes.leadTable}
            style={{ maxHeight: props.maxHeight, height: props.height }}
          >
            <Table stickyHeader aria-label="sticky table customized table">
              <TableHead>
                <TableRow>
                  <TableCell
                     key="play"
                     style={{
                     whiteSpace: "nowrap",
                       fontWeight: "bold",
                       textAlign: "center",
                        width: "50px",
                                  }}
                                >
                                  {"Recording File"}
                    </TableCell>

                    <TableCell
                     key="transcript"
                     style={{
                     whiteSpace: "nowrap",
                       fontWeight: "bold",
                       textAlign: "center",
                        width: "50px",
                                  }}
                                >
                                  {"Transcript"}
                    </TableCell>
                          
            
                  {visibleColumns.map((column) => (
      <TableCell
        key={column}
        style={{
          whiteSpace: "nowrap",
          fontWeight: "bold",
          textAlign: "center",
        }}
      >
        {column.replace(/_/g, " ").replace(/(^\w{1})|(\s{1}\w{1})/g, (match) =>
          match.toUpperCase()
        )}
      </TableCell>
    ))}
                </TableRow>
              </TableHead>
             
              <TableBody>
      {BucketData
  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((row, key) => {
          return (
            <>
            <TableRow hover role="checkbox" tabIndex={-1} key={key}>
        {/* Play Recording */}
        <TableCell
          key="play"
          style={{
            whiteSpace: "nowrap",
            textAlign: "center",
          
          }}
        >
          <div style={{  display: "flex",
            alignItems: "center",
            justifyContent: "center",}}> 
          {row["monitor_filename"] === "" ? (
            <IconButton color="default" title="No Voice Logger" disabled>
              <BlockIcon />
            </IconButton>
          ) : (
            <IconButton
              color="primary"
              title={
                playingSessionId === row["session_id"] && playingRowKey === key
                  ? isPlaying
                    ? "Pause Recording"
                    : "Resume Recording"
                  : "Play Recording"
              }
              onClick={() => handlePlayRecording(row["session_id"], key)}
            >
              {playingSessionId === row["session_id"] && playingRowKey === key ? (
                isPlaying ? (
                  <PauseCircleOutlineIcon />
                ) : (
                  <PlayCircleOutlineIcon sx={{ color: "#FF5C93" }} />
                )
              ) : (
                <PlayCircleOutlineIcon />
              )}
            </IconButton>
          )}
          {playingSessionId === row["session_id"] && playingRowKey === key && isPlaying && (
            <Waveform isActive={true} />
          )}
          </div>
        </TableCell>

        {/* Transcript */}
        <TableCell
          key="transcript"
          style={{ whiteSpace: "nowrap", textAlign: "center" }}
        >
          <IconButton
            color="primary"
            component="span"
            title="View Transcript"
            onClick={() => showTranscript(row["session_id"], row["cust_ph_no"], key)}
          >
            <ArticleIcon />
          </IconButton>
        </TableCell>

        {/* Visible Columns */}
        {visibleColumns.map((column, index) => {
          const value = row[column];
          return (
            <TableCell
              key={index}
              style={{
                whiteSpace: "nowrap",
                textAlign: "center",
                maxWidth: "300px",
              }}
            >
              {value?.trim() !== "" && column === "cust_ph_no" ? (
                props.facilityConf.enable_number_mask === "1" ? (
                  <TablePhoneNo
                    phone={maskedNumber(
                      value,
                      props.facilityConf.mask_start_pos,
                      props.facilityConf.mask_end_pos
                    )}
                    dialHandler={() => dialHandler(props.agentId, value, row["name"])}
                  />
                ) : (
                  <TablePhoneNo
                    phone={decryptPhoneNumber(value)}
                    dialHandler={() => dialHandler(props.agentId, value, row["name"])}
                  />
                )
              ) : column === "ph_type" ? (
               <span>
  {value !== null && value !== undefined
    ? `Phone ${value === "0" ? '0' : parseInt(value, 10) - 100}`
    : ''}
</span>
              ) : (
                <span
                  style={{
                    whiteSpace: "pre-wrap",
                    overflowWrap: "break-word",
                    maxWidth: "50px",
                  }}
                >
                  {value}
                </span>
              )}
            </TableCell>
          );
        })}
      </TableRow>
            </>
          );
        })}
    </TableBody>
    
            </Table>
          </TableContainer>
            <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  component="div"
                  count={BucketData.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
                 <CallProgressBox
                        selectedValue={selectedValue}
                        open={open}
                        handleClose={handleClose}
                      />    
       </>
      )
      : "No recent calls to display"       
    }          

   </Paper>

     </>
  )
}


const mapStateToProps = (state) => {
  return {
    error: state.agentDial.error,
    loading: state.agentDial.loading,
    leadError: state.customerDetails.error,
    leadLoading: state.customerDetails.loading,
    agentState: state.agentData.agentState,
    agentId: state.agentData.agentId,
    campaignId: state.agentData.campaignId,
    facilityConf: state.agentConfig.facilityConf,
    campConf : state.agentConfig.campConf,
    recentHisCalls: state.callAgentHistory.recentHisCalls,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAgentDial: (agentId, phone, leadId, listId, callerId) =>
      dispatch(actions.agentDial(agentId, phone, leadId,listId, callerId)),
    onGetCustomerDetails: (agentId, campaignId, leadId, leadType) =>
      dispatch(
        actions.getCustomerDetails(agentId, campaignId, leadId, leadType)
      ),
      onCallAgentHistory: (agentId,DateTime, limit, callDisp) => dispatch(actions.callAgentHistory(agentId, DateTime, limit, callDisp))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CallAgentHistory);
